export const MEDIA = {
  logo: "/bh-logo.png",
  heroImage: "https://images.pexels.com/photos/26859062/pexels-photo-26859062.jpeg?auto=compress&cs=tinysrgb&w=1920",
  heroVideo: "https://videos.pexels.com/video-files/8435818/8435818-sd_640_360_30fps.mp4",
  heroVideoAlt: "https://videos.pexels.com/video-files/36922676/15641309_640_360_30fps.mp4",
  overviewVideo: "https://videos.pexels.com/video-files/30670703/13125381_640_360_30fps.mp4",
  heroPoster: "https://images.unsplash.com/photo-1706164971302-e30c0640cc3b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  interiorLuxury: "https://images.unsplash.com/photo-1682184805271-11671b7ecf4c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  interiorBright: "https://images.unsplash.com/photo-1613545325278-f24b0cae1224?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  commercialSpace: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  painterWorking: "https://images.unsplash.com/photo-1709086566151-9a88641579b0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  painterBrick: "https://images.unsplash.com/photo-1759406066673-f76869a4e6db?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  swatches: "https://images.unsplash.com/photo-1581079948988-537795b40f5f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  sampleDigital: "https://images.pexels.com/photos/14299950/pexels-photo-14299950.jpeg?auto=compress&cs=tinysrgb&w=1200",
  samplePeel: "https://images.pexels.com/photos/4968717/pexels-photo-4968717.jpeg?auto=compress&cs=tinysrgb&w=1200",
  sampleCan: "https://images.pexels.com/photos/17959701/pexels-photo-17959701.jpeg?auto=compress&cs=tinysrgb&w=1200",
  consult: "https://images.pexels.com/photos/6474474/pexels-photo-6474474.jpeg?auto=compress&cs=tinysrgb&w=1400",
  rendering: "https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  renderScreen: "https://images.pexels.com/photos/6446682/pexels-photo-6446682.jpeg?auto=compress&cs=tinysrgb&w=1400",
  mansion: "https://images.unsplash.com/photo-1706855203772-c249b75fe016?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
};

export const STATS = [
  { value: "10+", label: "Years of Experience" },
  { value: "1:1", label: "Dedicated Color Designer" },
  { value: "1500+", label: "Jobs Completed" },
  { value: "5.0", label: "Average Client Rating" },
];

export const SEENON = ["HGTV", "DIY Network", "HBO"];

export const SEEN_LOGOS = [
  {
    name: "HGTV",
    url: "https://customer-assets-rejwkqb3.emergentagent.net/job_paint-perfection-la/artifacts/kej3b7iq_HGTV%20Logo%20Blue.jpeg",
    h: "h-10 md:h-12",
  },
  {
    name: "DIY Network",
    url: "https://customer-assets-rejwkqb3.emergentagent.net/job_paint-perfection-la/artifacts/a6fmcfe6_DIY%20Network%20Logo.jpeg",
    h: "h-12 md:h-14",
  },
  {
    name: "HBO",
    url: "https://customer-assets-rejwkqb3.emergentagent.net/job_paint-perfection-la/artifacts/n3wfdo7j_HBO%20Logo.png",
    h: "h-12 md:h-14",
  },
];

/**
 * Instagram Reels strip (homepage). Each entry either:
 *   - links out to the profile if `url` is the profile URL, OR
 *   - can be a specific reel URL once you have them (e.g. https://www.instagram.com/reel/XXXX/)
 * Swap the `img` and `caption` for each tile as new reels drop.
 */
export const IG_HANDLE = "beverlyhillspaint";
export const IG_PROFILE_URL = "https://www.instagram.com/beverlyhillspaint";
export const INSTAGRAM_REELS = [
  {
    url: IG_PROFILE_URL,
    img: "https://images.unsplash.com/photo-1618221118493-9cfa1a1c00da?auto=format&fit=crop&w=800&q=80",
    caption: "Editorial-grade interiors, one estate at a time.",
  },
  {
    url: IG_PROFILE_URL,
    img: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=800&q=80",
    caption: "Before → After · Beverly Hills master suite.",
  },
  {
    url: IG_PROFILE_URL,
    img: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=800&q=80",
    caption: "Cabinet respray · Malibu new-build.",
  },
];

export const PAINTS = [
  {
    brand: "Sherwin-Williams",
    blurb: "An industry benchmark for color depth and longevity, and our go-to for rich, true-to-swatch finishes inside and out.",
    groups: [
      { title: "Interior", items: ["Emerald & Emerald Designer Edition", "SuperPaint", "Symmetry", "ProBlock Premium (primer)"], link: "https://www.sherwin-williams.com/painting-contractors/products/interior-paint-coatings/paint-coatings-interior" },
      { title: "Exterior", items: ["Emerald (exterior)", "SuperPaint (exterior)", "ProBlock Premium (primer)"], link: "https://www.sherwin-williams.com/painting-contractors/products/exterior-paint-coatings/paint-coatings-exterior" },
      { title: "Commercial / High-Performance", items: ["Pro Industrial (commercial)"], link: "https://www.sherwin-williams.com/painting-contractors/products/interior-paint-coatings/interior-commercial-highperformance-coatings" },
    ],
  },
  {
    brand: "Benjamin Moore",
    blurb: "A hand-selected favorite of interior designers for depth, coverage and true-to-swatch color — the paint of choice on many of America's finest homes.",
    groups: [
      { title: "Interior", items: ["Aura Interior (premium)", "Regal Select Interior", "Advance (cabinets, doors & trim)", "Fresh Start (primer)"], link: "https://www.benjaminmoore.com/en-us/paint-stains/product-catalog/interior-paints" },
      { title: "Exterior", items: ["Aura Exterior (premium)", "Regal Select Exterior", "Ultra Spec EXT", "Fresh Start (exterior primer)"], link: "https://www.benjaminmoore.com/en-us/paint-stains/product-catalog/exterior-paints" },
      { title: "Commercial / High-Performance", items: ["Ultra Spec 500 (commercial interior)", "Ultra Spec HP (interior/exterior)"], links: [
        { label: "Interior", url: "https://www.benjaminmoore.com/en-us/paint-stains/product-catalog/interior-paints" },
        { label: "Exterior", url: "https://www.benjaminmoore.com/en-us/paint-stains/product-catalog/exterior-paints" },
      ] },
    ],
  },
];

export const BLOG = [
  {
    slug: "2026-colors-of-the-year",
    title: "2026 Colors of the Year",
    excerpt: "Sherwin-Williams and Benjamin Moore just named their 2026 colors, and here's how to use them at home.",
    date: "January 6, 2026",
    category: "Color Trends",
    image: "https://customer-assets.emergentagent.com/job_paint-perfection-la/artifacts/8pgt2ra3_Color%20of%20the%20year%202026%20sw.webp",
    body: [
      "Every year the major paint houses crown a Color of the Year, and 2026 is all about warmth and grounding. Both of our go-to manufacturers have made beautiful, livable choices that translate especially well to Los Angeles homes.",
      "Sherwin-Williams named Universal Khaki (SW 6150) its 2026 Color of the Year. It is a soft, sun-warmed neutral, a versatile greige-khaki that flatters our golden California light and pairs effortlessly with oak, natural stone, and brass. It makes an elegant whole-home backdrop and a sophisticated alternative to the cool grays of the last decade.",
      "Benjamin Moore chose Silhouette (AF-655), a rich espresso brown with delicate charcoal undertones. Inspired by the confidence of classic tailoring, it is warm, grounding and unexpectedly versatile — beautiful on built-ins, a study, cabinetry or a moody powder room, layered against warm neutrals and natural wood for a rich, collected feel.",
      "Our advice: use Universal Khaki as your calm, timeless canvas and bring in Silhouette as a considered accent, on a bookcase, an island, a powder room, or a front door. Together they capture exactly where luxury color is heading in 2026 while keeping your home feeling collected rather than trend-driven.",
    ],
    gallery: [
      { url: "https://customer-assets.emergentagent.com/job_paint-perfection-la/artifacts/8pgt2ra3_Color%20of%20the%20year%202026%20sw.webp", caption: "Sherwin-Williams 2026 Color of the Year: Universal Khaki (SW 6150)" },
      { url: "https://customer-assets.emergentagent.com/job_paint-perfection-la/artifacts/g9xr7ipm_color%20of%20the%20year%202026%20de.webp", caption: "Benjamin Moore 2026 Color of the Year: Silhouette (AF-655)" },
    ],
  },
  {
    slug: "timeless-vs-trendy-paint-colors",
    title: "Timeless vs. Trendy Paint Colors",
    excerpt: "How to enjoy of-the-moment color without dating your home, from our design team.",
    date: "December 15, 2025",
    category: "Design Tips",
    image: "https://images.pexels.com/photos/4968717/pexels-photo-4968717.jpeg?auto=compress&cs=tinysrgb&w=1400",
    body: [
      "There is nothing wrong with a trendy color. The trouble starts when a whole home is painted in a shade that will feel dated in a few years. The smartest approach is to decide which surfaces should be timeless and which can be playful.",
      "Timeless colors are your big commitments: exterior body, main living walls, kitchen cabinetry. Here we lean into warm whites, soft greiges, and classic deep neutrals that flatter almost any furnishing and hold their value at resale.",
      "Trendy colors belong where they are easy to change: a powder room, a built-in bookcase, an accent wall, or a front door. These small moments let you enjoy the color of the moment while keeping the bones of your home elegant and enduring. When you want to refresh, only a fraction of the house needs attention.",
    ],
  },
  {
    slug: "best-time-of-year-to-paint-your-house",
    title: "The Best Time of Year to Paint Your House",
    excerpt: "Timing your project for the best finish, especially for exteriors in Southern California.",
    date: "November 24, 2025",
    category: "Homeowner Guide",
    image: "https://images.pexels.com/photos/17959701/pexels-photo-17959701.jpeg?auto=compress&cs=tinysrgb&w=1400",
    body: [
      "For interiors, you can paint year round. Climate control means the main variables are ventilation and dry time, so almost any season works well for indoor projects.",
      "Exteriors are more sensitive. Paint cures best in mild, dry conditions with moderate temperatures and low humidity. In Southern California that gives us a long, generous window, but the sweet spots are late spring and early fall, when days are warm but not scorching and overnight temperatures stay stable.",
      "We avoid painting exteriors in the heat of extreme summer afternoons, when surfaces get too hot and paint can dry too fast, and we watch for the occasional rainy stretch in winter. If you are planning an exterior refresh, reach out early so we can schedule your project during the ideal window and lock in the flawless finish your home deserves.",
    ],
  },
];


export const SERVICES = [
  { title: "Residential Painting", desc: "Interior and exterior finishes for estates, mansions, and luxury homes across LA.", img: MEDIA.interiorBright },
  { title: "Commercial Painting", desc: "Showrooms, offices, and hospitality spaces finished to an impeccable standard.", img: MEDIA.commercialSpace },
  { title: "Specialty Finishes", desc: "Venetian plaster, lacquer, cabinetry, and bespoke decorative detailing.", img: MEDIA.interiorLuxury },
];

export const PORTFOLIO = [
  { name: "Beverly Hills Estate", loc: "Beverly Hills", img: MEDIA.mansion, span: "md:col-span-7" },
  { name: "Malibu Cliffside", loc: "Malibu", img: MEDIA.heroPoster, span: "md:col-span-5" },
  { name: "Hollywood Hills Modern", loc: "Hollywood Hills", img: MEDIA.interiorLuxury, span: "md:col-span-5" },
  { name: "Palisades Villa", loc: "Pacific Palisades", img: MEDIA.interiorBright, span: "md:col-span-7" },
];

export const AREAS = ["Beverly Hills","Los Angeles","West Hollywood","Hollywood Hills","Malibu","Pacific Palisades","Calabasas","Santa Monica","Marina Del Rey","Culver City","Studio City","Sherman Oaks","Glendale","Burbank","Redondo Beach","Palos Verdes Peninsula"];

export const TESTIMONIALS = [
  { name: "Alexandra M.", loc: "Beverly Hills", text: "They transformed our home with exceptional craftsmanship and attention to detail. The entire process was professional, organized, and the results exceeded our expectations." },
  { name: "Jonathan R.", loc: "Malibu", text: "Flawless finishes and a team that treated our estate like their own. Truly a white-glove experience from consultation to completion." },
  { name: "Priya S.", loc: "Pacific Palisades", text: "The most meticulous painters we have ever hired. Every edge, every coat, perfection. Worth every dollar." },
];

export const FAQ = [
  { q: "What types of services do you offer?", a: "Full-service interior and exterior painting, both residential and commercial. We also offer specialty finishes, cabinetry refinishing, patio, deck, fence and gate painting. Along with these we also offer design services to our clients to help keep the process seamless." },
  { q: "How long does a project take?", a: "Timelines depend on scope. A single room may take 1–2 days; a full interior or exterior can take anywhere from 5–10 days depending on the size. We provide a detailed schedule with every estimate." },
  { q: "What paint do you use?", a: "We work with two premium manufacturers, Sherwin-Williams and Benjamin Moore, and the choice comes down to your preference. From Sherwin-Williams we use Emerald, SuperPaint and Symmetry with ProBlock Premium as our primer, and Pro Industrial for commercial projects. From Benjamin Moore we use Aura and Regal Select for interiors, Aura Exterior and Regal Select Exterior for exteriors, Advance for cabinetry, doors and trim, and Fresh Start as our primer, plus Ultra Spec 500 and Ultra Spec HP for commercial work. You can see the full breakdown on our Paints we use page." },
  { q: "Do you provide free estimates?", a: "Yes. Every project begins with a complimentary on-site consultation and a transparent, itemized estimate." },
];
